/* globals $ */
import Filter from './filter';
import urlParams from '../utils/url-params';

/* eslint-disable react/prefer-stateless-function, react/sort-comp */

const defaults = {};

export default class AjaxPagination extends Filter {
  constructor($context, options) {
    super($context, Object.assign({}, defaults, options));

    this.$context = $context;
    this.$buttonPrev = this.$context.find('.js-pagination-less');
    this.$buttonNext = this.$context.find('.js-pagination-more');
    this.$buttons = this.$buttonNext.add(this.$buttonPrev);
    this.$metadata = this.$context.find('.js-pagination-metadata');
    this.$searchResult = this.$context.find('.js-pagination-results');

    if (!this.$buttonPrev.length) throw new Error('No .js-pagination-less element in .js-pagination');
    if (!this.$buttonNext.length) throw new Error('No .js-pagination-more element in .js-pagination');
    if (!this.$metadata.length) throw new Error('No .js-pagination-metadata element in .js-pagination');
    if (!this.$searchResult.length) throw new Error('No .js-pagination-results element in .js-pagination');

    this.direction = '';
    this.filter = {};
    this.currentPage = null;
    this.totalPages = null;

    this.init();
  }

  init() {
    this.initMetadata();
    this.initButtonsVisibility();
    this.initButtonsEvents();
  }

  initMetadata() {
    this.updateMetadata();
  }

  initButtonsVisibility() {
    this.updateButtons();
  }

  initButtonsEvents() {
    this.$buttons.on('click', e => {
      e.preventDefault();

      const $a = $(e.currentTarget);
      const href = $a.attr('href');

      // Jezeli się ładuje to nic nie rób
      if ($a.hasClass('loading')) {
        return;
      }

      // Ładowanie contentu z href
      this.direction = +$a.attr('data-direction');
      this.getResults(href);
      AjaxPagination.updatePageUrl(href);
    });
  }

  setFilter(filter) {
    this.filter = filter;
    this.direction = 0;

    let href = window.location.href;
    let params = urlParams.get(href);

    params.page = 1;
    params = Object.assign({}, params, this.filter);
    href = urlParams.set(href, params);

    this.getResults(href);
    AjaxPagination.updatePageUrl(href);
  }

  toggleLoader(stan = false) {
    const $elements = this.$buttons.add(this.$searchResult);

    $elements.removeClass('loading-dir-1 loading-dir0 loading-dir1');

    if (stan) {
      $elements.addClass(`loading-dir${this.direction}`);
    }

    $elements.toggleClass('loading', stan);
  }

  appendResults(re) {
    this.updateResults($(re));
    this.toggleLoader(false);
  }

  updateResults($output) {
    this.$lastOutput = $output;

    if (this.direction === 1) {
      this.$searchResult.append($output);
      this.updateMetadata();
      this.updateButtonNext();
    } else if (this.direction === -1) {
      this.$searchResult.prepend($output);
      this.updateMetadata();
      this.updateButtonPrev();
    } else {
      this.$searchResult.html($output);
      this.updateMetadata();
      this.updateButtonNext();
      this.updateButtonPrev();
    }

    this.fire('contentLoaded');
  }

  updateMetadata() {
    this.$metadata = this.$context.find('.js-pagination-metadata');

    if (this.$metadata.length) {
      this.currentPage = +this.$metadata.attr('data-current-page');
      this.totalPages = +this.$metadata.attr('data-total-pages');
    }

    this.$metadata.remove();
  }

  updateButtons() {
    this.updateButtonNext();
    this.updateButtonPrev();
  }

  updateButtonNext() {
    // Update next button visibility
    this.$buttonNext.toggleClass('hidden', !(this.totalPages > this.currentPage));

    // Update button link
    let href = this.$buttonNext.attr('href');
    let params = urlParams.get(href);

    params.page = this.currentPage + 1;
    params = Object.assign({}, params, this.filter);
    href = urlParams.set(href, params);

    this.$buttonNext.attr('href', href);
  }

  updateButtonPrev() {
    // Update prev button visibility
    if (this.currentPage > 1) {
      this.$buttonPrev.closest('.load-less-wrapper').slideDown('normal');
    } else {
      this.$buttonPrev.closest('.load-less-wrapper').slideUp('normal');
    }

    // Update button link
    let href = this.$buttonPrev.attr('href');
    let params = urlParams.get(href);

    params.page = this.currentPage - 1;
    params = Object.assign({}, params, this.filter);
    href = urlParams.set(href, params);

    this.$buttonPrev.attr('href', href);
  }

  static updatePageUrl(url) {
    window.history.pushState('', '', url);
  }

  static initialize($context = $(document.body), options = {}) {
    return super.initialize('.js-pagination', AjaxPagination, 'AjaxPagination', $context, options);
  }
}



// WEBPACK FOOTER //
// ./front/bankomania/js/components/ajax-pagination.js